function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-figma-1264470");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-figma-1264470",
  transform: "translate(0.867000, 0.977000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M86.173,167.953 C39.982,167.953 2.189,130.16 2.189,83.969 C2.189,37.789 39.982,-1.42108547e-14 86.173,-1.42108547e-14 L253.463,-1.42108547e-14 C299.643,-1.42108547e-14 337.436,37.789 337.436,83.969 C337.436,130.16 299.643,167.953 253.463,167.953 L86.173,167.953 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.953,360.203 L169.453,360.203 L169.453,192.203 L83.953,192.203 C60.902,192.203 39.894,201.6444 24.668,216.871 C9.445,232.098 2.84217094e-14,253.121 2.84217094e-14,276.246 C2.84217094e-14,322.41 37.777,360.203 83.953,360.203",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.603,193.923 C215.232,193.923 177.619,231.517 177.619,277.907 C177.619,324.282 215.232,361.876 261.603,361.876 C307.978,361.876 345.587,324.282 345.587,277.907 C345.587,231.516 307.978,193.923 261.603,193.923",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.313,384.153 L82.317,384.153 L82.317,384.32097 C37.426,386.00067 1.524,422.82497 1.524,468.13697 C1.524,514.51197 39.122,552.10997 85.493,552.10997 C130.431,552.10997 167.028,516.78197 169.266,472.40697 L169.312876,472.40697 L169.312876,471.45385 C169.355844,470.34835 169.476936,469.25855 169.476936,468.13745 C169.476936,467.02025 169.355846,465.93045 169.312876,464.80935 L169.313,384.153 Z",
  id: "Path"
})));

var SvgFigma = function SvgFigma(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "347px",
    height: "554px",
    viewBox: "0 0 347 554",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFigma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Figma.95f17142.svg";
export { ForwardRef as ReactComponent };